import type { Theme } from '@mui/material';
import { Link, useTheme } from '@mui/material';
import { Text } from '@theguarantors/tg-package-material-ui';

const MAXIMUM_ALLOWED_CHARACTERS_EMAIL = 30;

const RenterInviteSuccessToastMessage = ({ emailText }: { emailText: string }) => {
  const theme = useTheme();

  return (
    <>
      <Text.HeaderEmphasizedSmall
        sx={{
          fontSize: '16px !important',
          fontWeight: 500,
        }}
      >
        Invitation sent
      </Text.HeaderEmphasizedSmall>
      <Text.BodyEmphasizedSmall
        sx={{
          fontSize: '16px !important',
          color: theme.palette.neutralGrey?.[700],
          wordBreak: 'break-all',
        }}
      >
        {emailText?.length > MAXIMUM_ALLOWED_CHARACTERS_EMAIL ? '...' : ''}
        {emailText?.slice(-MAXIMUM_ALLOWED_CHARACTERS_EMAIL)}
      </Text.BodyEmphasizedSmall>
    </>
  );
};

const RenterInviteSuccessToastCta = ({ onClick }: { onClick: () => void }) => {
  const theme = useTheme();

  return (
    <Link
      component="button"
      color="inherit"
      underline="none"
      onClick={onClick}
      sx={{
        fontWeight: 700,
        cursor: 'pointer',
        color: theme.palette.green?.[700],
      }}
    >
      Invite another
    </Link>
  );
};

export const createSuccessToastParams = ({
  emails,
  onInviteAnother,
  theme,
}: {
  emails: string[];
  onInviteAnother: () => void;
  theme: Theme;
}) => ({
  message: <RenterInviteSuccessToastMessage emailText={emails[0] ?? ''} />,
  config: {
    sx: {
      maxWidth: '400px',
      border: `1px solid ${theme.palette.green?.[700] ?? theme.palette.success.main}`,
      '& .MuiAlert-action': {
        mx: 0,
        minWidth: 'fit-content !important',
      },
    },
  },
  cta: <RenterInviteSuccessToastCta onClick={onInviteAnother} />,
});
